export { default as coursesLocaleEs } from './localeEs';
export { default as coursesLocalePt } from './localePt';
export { default as coursesLocaleEn } from './localeEn';
